<template>
  <div class="bar-container">
    <span class="bar-title"> {{ title }}</span>
    <div :class="bold ? 'bar-content bold' : 'bar-content'">
      <span v-html="content" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'DetailBar',
  props: {
    title: {
      type: [String, Number],
      default: ''
    },
    content: {
      type: [String, Number],
      default: ''
    },
    bold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped lang="scss">
.bar-container {
  .bar-title {
    height: 22px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #646A73;
    line-height: 22px;
  }
  .bar-content {
    line-height: 22px;
    background: #F7F9FB;
    border-radius: 4px;
    padding: 5px 12px;
    margin-top: 8px;
    font-size: 14px;
    font-family: HelveticaNeue-Medium, HelveticaNeue;
    color: #1F2329;
    font-weight: 400;
    margin-bottom: 16px;
  }
  .bold {
    font-size: 18px;
    font-family: HelveticaNeue-Medium, HelveticaNeue;
    font-weight: bold;
    color: #1F2329;
  }
}
</style>
